import { Component } from '@angular/core';
import { RidMorphemeBoardFreeform } from '../../../../mechanics/rid-morpheme-board-freeform/rid-morpheme-board-freeform';

@Component({
  selector: 'app-morpheme-board-freeform-page',
  imports: [RidMorphemeBoardFreeform],
  templateUrl: './morpheme-board-freeform-page.html',
})
export class MorphemeBoardFreeformPage {}
